import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {map, Observable} from "rxjs";

import {WebResponse} from "@commons/models/remote.response/WebResponse";

import {WorkerModel} from "@shared/models/worker.model";
import {BaseHttpService} from "@shared/services-http/base-http.service";

@Injectable({
  providedIn: 'root'
})
export class WorkerHttpService extends BaseHttpService {

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  add(worker: WorkerModel): Observable<number> {
    return this.httpClient.post<WebResponse<any>>(this.getUrl('/AddWorker'), {Worker: worker})
      .pipe(map(x => x.Result.WorkerId));
  }

  update(worker: WorkerModel): Observable<WebResponse> {
    return this.httpClient.post<WebResponse>(this.getUrl('/UpdateWorker'), {Worker: worker});
  }

  archive(id: number | null, listOfWorkerToArchive?: number[]): Observable<WebResponse> {
    return this.httpClient.post<WebResponse>(this.getUrl('/ArchiveWorkers'), {IdsToArchive: listOfWorkerToArchive ? listOfWorkerToArchive : [id]});
  }

  unarchive(id: number): Observable<WebResponse> {
    return this.httpClient.post<WebResponse>(this.getUrl('/UnarchiveWorker'), {WorkerId: id});
  }

  getArchivedWorkers(): Observable<WorkerModel[]> {
    return this.httpClient.get<WebResponse>(this.getUrl('/GetArchivedWorkers')).pipe(map(x => x.Result.ArchivedWorkers));
  }
}
